import type { ActivityModule } from '../../core/activity';
import { runAlgebraActivity } from '../../shared/algebra-runner';
import type { AlgebraLevel } from '../../shared/algebra-runner';
import levelsData from './levels.json';

export const algebraMinus: ActivityModule = {
  id: 'algebra_minus',
  title: 'Subtração',
  description: 'Pratique a subtração com tabuadas progressivas (1 ao 10). Resultado sempre não-negativo.',
  ageMin: 7,
  ageMax: 10,
  difficulty: 4,
  iconPath: 'assets/gcompris-AGPL/algebra_minus/icon.svg',
  category: 'aritmetica',
  totalLevels: levelsData.levels.length,
  mount(ctx) {
    return runAlgebraActivity(ctx, {
      activityId: 'algebra_minus',
      title: 'Subtração',
      operator: '−',
      compute: (a, b) => a - b,
      levels: levelsData.levels as AlgebraLevel[],
    });
  },
};
